import { shopConstants } from "../constants";
import { shopService } from "../services";

export const shopActions = {
    isShopPublic,
    getPublicShop,
    getPublicShopConfig
};

function isShopPublic(shop_id = 0) {
    return dispatch => {
        dispatch(request());
        shopService.isShopPublic(shop_id).then(
            res => dispatch(success(res)),
            err => dispatch(error(err))
        );
    };

    function request() {
        return { 
            type: shopConstants.IS_SHOP_PUBLIC_REQUEST
        };
    }
    function success(shop) {
        return { 
            type: shopConstants.IS_SHOP_PUBLIC_SUCCESS,
            payload: shop?.data || []
        };
    }
    function error(err = {}) {
        return { 
            type: shopConstants.IS_SHOP_PUBLIC_ERROR,
            payload: err
        };
    }
}


function getPublicShop(shop_id = 0) {
    return dispatch => {
        dispatch(request());
        shopService.getPublicShop(shop_id).then(
            res => dispatch(success(res)),
            err => dispatch(error(err))
        );
    };

    function request() {
        return { 
            type: shopConstants.GET_PUBLIC_SHOP_REQUEST
        };
    }
    function success(shop) {
        return { 
            type: shopConstants.GET_PUBLIC_SHOP_SUCCESS,
            payload: shop?.data || {}
        };
    }
    function error(err = {}) {
        return { 
            type: shopConstants.GET_PUBLIC_SHOP_ERROR,
            payload: err
        };
    }
}

function getPublicShopConfig(shop_id = 0) {
    return dispatch => {
        dispatch(request());
        shopService.getPublicShopConfig(shop_id).then(
            res => dispatch(success(res)),
            err => dispatch(error(err))
        );
    };

    function request() {
        return { 
            type: shopConstants.GET_PUBLIC_SHOP_CONFIG_REQUEST
        };
    }
    function success(config) {
        return { 
            type: shopConstants.GET_PUBLIC_SHOP_CONFIG_SUCCESS,
            payload: config?.data || {}
        };
    }
    function error(err = {}) {
        return { 
            type: shopConstants.GET_PUBLIC_SHOP_CONFIG_ERROR,
            payload: err
        };
    }
}